import classNames from "classnames";
import { ChartSpline, FileText, Folder } from "lucide-react";

import { type ContextType } from "../contextType";

interface ContextIconProps {
  contextType: ContextType;
  className?: classNames.Argument;
}

/**
 * Context icon component for a given context type.
 */
export function ContextIcon(props: ContextIconProps) {
  const { contextType, className } = props;

  switch (contextType) {
    case "dataset":
      return <Folder className={classNames(className)} />;
    case "file":
      return <FileText className={classNames(className)} />;
    case "viz_state":
      return <ChartSpline className={classNames(className)} />;
  }
}
